import http from '@/services/HttpService';

export default {
  async create (data) {
    const res = await http().post('/api/v1/newsletters', data);
    return res.data;
  },
};
